import Swiper from 'swiper';
import { EffectFade, Navigation, A11y } from 'swiper/modules';
// Swiper's CSS exports resolve in Webpack; ESLint's legacy resolver lacks exports support.
// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/effect-fade';
import '../../sass/blocks/hero-slider.scss';

const ROOT_SELECTOR = '[data-hero-slider]';
const TRANSITION_DURATION = 500;
const instances = new Map();
const previews = new WeakSet();

const initializeSlider = (root) => {
    if (root.hasAttribute('data-editor-preview') && !previews.has(root)) {
        root.addEventListener('click', (event) => {
            if (event.target.closest('a')) event.preventDefault();
        });
        previews.add(root);
    }
    if (root.swiper) return;
    const controls = root.querySelector('[data-hero-controls]');
    if (!controls) return;

    const current = root.querySelector('[data-hero-current]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const transitionDuration = document.body.classList.contains('ovalia-motion') && !root.hasAttribute('data-editor-preview')
        ? 850 : TRANSITION_DURATION;
    const syncSlides = (swiper) => {
        current.textContent = String(swiper.realIndex + 1).padStart(2, '0');
        swiper.slides.forEach((slide, index) => {
            const active = index === swiper.activeIndex;
            slide.toggleAttribute('inert', !active);
            slide.setAttribute('aria-hidden', String(!active));
        });
    };
    const slider = new Swiper(root, {
        modules: [EffectFade, Navigation, A11y],
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: reducedMotion.matches ? 0 : transitionDuration,
        rewind: true,
        watchOverflow: true,
        grabCursor: true,
        navigation: {
            prevEl: root.querySelector('[data-hero-prev]'),
            nextEl: root.querySelector('[data-hero-next]'),
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Poprzedni slajd',
            nextSlideMessage: 'Następny slajd',
            slideLabelMessage: '{{index}} z {{slidesLength}}',
        },
        on: { init: syncSlides, slideChange: syncSlides },
    });
    const updateMotion = ({ matches }) => {
        slider.params.speed = matches ? 0 : transitionDuration;
    };
    reducedMotion.addEventListener('change', updateMotion);
    const navigateByKeyboard = (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        if (event.target.closest('.swiper-slide')) {
            const direction = event.key === 'ArrowLeft' ? 'prev' : 'next';
            root.querySelector(`[data-hero-${direction}]`).focus({ preventScroll: true });
        }
        if (event.key === 'ArrowLeft') slider.slidePrev();
        else slider.slideNext();
    };
    root.addEventListener('keydown', navigateByKeyboard);
    slider.on('destroy', () => {
        reducedMotion.removeEventListener('change', updateMotion);
        root.removeEventListener('keydown', navigateByKeyboard);
        instances.delete(root);
    });
    instances.set(root, slider);
    controls.hidden = false;
};

const initializeWithin = (scope = document) => {
    instances.forEach((slider, root) => {
        if (!root.isConnected) slider.destroy();
    });
    if (!scope) return;
    if (scope.matches?.(ROOT_SELECTOR)) initializeSlider(scope);
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initializeSlider);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin(), { once: true });
} else {
    initializeWithin();
}

if (window.acf) {
    window.acf.addAction('render_block_preview/type=hero-slider', ($block) => {
        initializeWithin($block[0]);
    });
}
